import { GlobalStyles, GlobalStylesNoFont } from '@shortlyster/ui-kit';
import { HEADLESS_TESTING } from 'lib/env';

export default HEADLESS_TESTING ? GlobalStylesNoFont : GlobalStyles;
